module.exports = __webpack_public_path__ + "static/media/logo.f45faed6.webp";